import {  Tooltip } from "antd";
import React from "react";
import PropTypes from "prop-types";


export const GenericToolTip = ({toolTipData, tooltipText}) => {
    return (
        <Tooltip title={tooltipText}>
            {toolTipData}
        </Tooltip>
    );
};

GenericToolTip.propTypes = {
    toolTipData: PropTypes.object,
    tooltipText: PropTypes.string,
};
